module.exports = __webpack_public_path__ + "static/media/mood-sad.e92a74bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/mood-sad.svg
// module id = 528
// module chunks = 31